export const run = () => {
    window.addEventListener('scroll', observeParallax);

}
export const remove = () => {
    
    window.removeEventListener('scroll', observeParallax)
}
function observeParallax (data) {
       
    const prllxcont = document.querySelectorAll('.parallax-container')
    prllxcont.forEach(element => {

        var p1 = document.getElementsByClassName('k-parallax-1')
        var p2 = element.getElementsByClassName('k-parallax-2')
        var p3 = element.getElementsByClassName('k-parallax-3')
        var p4 = element.getElementsByClassName('k-parallax-4')
        var p5 = element.getElementsByClassName('k-parallax-5')
        var p6 = element.getElementsByClassName('k-parallax-6')
        var p7 = element.getElementsByClassName('k-parallax-7')
        var p8 = element.getElementsByClassName('k-parallax-8')
        var p9 = element.getElementsByClassName('k-parallax-9')
        var p10 = element.getElementsByClassName('k-parallax-10')
        var p11 = element.getElementsByClassName('k-parallax-11')
        var p12 = element.getElementsByClassName('k-parallax-12')
        var p13 = element.getElementsByClassName('k-parallax-13')
        var p14 = element.getElementsByClassName('k-parallax-14')

        let marginWintop = element.getBoundingClientRect().top; 
        let winHeigh = window.innerHeight;
        let difference = winHeigh - (winHeigh - marginWintop);

        let p1n;
        for (p1n = 0; p1n < p1.length; p1n++) {
            p1[p1n].style.top = difference * .05 + 'px';
        }
        let p2n;
        for (p2n = 0; p2n < p2.length; p2n++) {
            p2[p2n].style.top = difference * .1 + 'px'
        }
        let p3n;
        for (p3n = 0; p3n < p3.length; p3n++) {
            p3[p3n].style.top = difference * .15 + 'px'
        }

        let p4n;
        for (p4n = 0; p4n < p4.length; p4n++) {
            p4[p4n].style.top = -difference * .05 + 'px'
        }
        let p5n;
        for (p5n = 0; p5n < p5.length; p5n++) {
            p5[p5n].style.top = difference * .20 + 'px'
        }

        let p6n;
        for (p6n = 0; p6n < p6.length; p6n++) {
            p6[p6n].style.top = -difference * .1 + 'px';
        }
        let p7n;
        for (p7n = 0; p7n < p7.length; p7n++) {
            p7[p7n].style.top = difference * .25 + 'px'
        }
        let p8n;
        for (p8n = 0; p8n < p8.length; p8n++) {
            p8[p8n].style.top = -difference * .15 + 'px'
        }
        let p9n;
        for (p9n = 0; p9n < p9.length; p9n++) {
            p9[p9n].style.top = difference * .30 + 'px'
        }
        let p10n;
        for (p10n = 0; p10n < p10.length; p10n++) {
            p10[p10n].style.top = -difference * .2 + 'px'
        }
        let p11n;
        for (p11n = 0; p11n < p11.length; p11n++) {
            p11[p11n].style.top = difference * .35 + 'px'
        }
        let p12n;
        for (p12n = 0; p12n < p12.length; p12n++) {
            p12[p12n].style.top = difference * .40 + 'px'
        }
        let p13n;
        for (p13n = 0; p13n < p13.length; p13n++) {
            p13[p13n].style.top = -difference * .25 + 'px'
        }
        let p14n;
        for (p14n = 0; p14n < p14.length; p14n++) {
            p14[p14n].style.top = difference * .45 + 'px'
        }
       
    });
}
    
